export default __webpack_public_path__ + "static/media/emptyBookmark.0b31870d.svg";